import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { WebCrashReportInterface } from './definitions';
import { CAPACITOR_WEB_CRASH_REPORT_PLUGIN } from '../pluginConstants';

const WebCrashReportPluginRaw = registerPlugin<WebCrashReportInterface>(CAPACITOR_WEB_CRASH_REPORT_PLUGIN);
const WebCrashReportPlugin = withBridgedStackTrace(WebCrashReportPluginRaw, CAPACITOR_WEB_CRASH_REPORT_PLUGIN);

export * from './definitions';
export { WebCrashReportPlugin };
